/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { IndividualPaymentInvoiceViewModel } from "../types/IndividualPaymentInvoiceViewModel.ts";

export const individualPaymentInvoiceViewModelSchema = z.object({
  nfeNumber: z.string().nullish(),
  status: z.optional(z.number().int()),
  statusText: z.string().nullish(),
  statusReason: z.string().nullish(),
  nfeVerificationCode: z.string().nullish(),
  nfeRpsNumber: z.string().nullish(),
  nfeRpsSerie: z.string().nullish(),
  nfeCompetenceDate: z.string().datetime().nullish(),
}) as unknown as ToZod<IndividualPaymentInvoiceViewModel>;
